function updateFnProductsSliderArrows(swiper) {
  const nav = swiper.el.querySelector('.swiper_navigation_block');
  if (!nav) return;

  const slideCount = swiper.slides.length;
  let perView = parseFloat(swiper.params.slidesPerView, 10);
  if (Number.isNaN(perView)) perView = 1;

  nav.classList.toggle('swiper_navigation_block--no-arrows', slideCount <= perView);
}

function initFnProductsSliderRoot(root) {
  const slider = root.querySelector('.fn-products-slider__slider');
  if (!slider || !slider.id || typeof Swiper === 'undefined') return;
  if (slider.swiper) slider.swiper.destroy(true, true);

  new Swiper('#' + slider.id, {
    slidesPerView: 1.4,
    spaceBetween: 15,
    breakpoints: {
      576: { slidesPerView: 2, spaceBetween: 15 },
      768: { slidesPerView: 3, spaceBetween: 15 },
      992: { slidesPerView: 4, spaceBetween: 24 },
    },
    navigation: {
      nextEl: '#' + slider.id + ' .swiper-button-next',
      prevEl: '#' + slider.id + ' .swiper-button-prev',
    },
    pagination: {
      el: '#' + slider.id + ' .swiper-pagination',
      clickable: true,
    },
    on: {
      init() {
        updateFnProductsSliderArrows(this);
      },
      resize() {
        updateFnProductsSliderArrows(this);
      },
      breakpoint() {
        updateFnProductsSliderArrows(this);
      },
    },
  });
}

function initFnProductsSliders(scope) {
  const container = scope || document;
  container.querySelectorAll('[data-fn-products-slider]').forEach(initFnProductsSliderRoot);
}

function bootFnProductsSliders() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initFnProductsSliders());
  } else {
    initFnProductsSliders();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initFnProductsSliders(event.target);
  });
}

bootFnProductsSliders();
